import React, { useState, useEffect } from 'react';
import moment from 'moment';
import copy from 'copy-to-clipboard';

import { Input } from '../../../elements';
import { showSuccess } from '../../../elements/Toasts/toastActions';
import { ReactComponent as RefreshIcon } from '../../../styles/icon/refresh.svg';
import { webhooksActions } from '../../../redux/reducers/webhooks';
import { secrets } from '../../../redux/reducers/webhook';
import { useAppSelector, useAppDispatch } from '../../../hooks/useRedux';
import strings from '../../../lang/lang';
import settings from '../Settings.module.scss';


function WebHookSecrets() {
  const [secretLabel, setSecretLabel] = useState('');
  const dispatch = useAppDispatch();
  const webhookSecrets = useAppSelector(secrets);

  useEffect(() => {
    let label = strings.appWebhookDetails.fields.limitedSecret;
    const limitedSecret = webhookSecrets.find((c) => c.expiredAt) || {};
    if (limitedSecret.expiredAt) {
      const expiredDate = moment.utc(limitedSecret.expiredAt).local().format('YYYY-MM-DD HH');
      label = strings.appWebhookDetails.fields.limitedSecret + ' (VALID UNTIL ' + expiredDate + ')';
    }
    setSecretLabel(label);
  }, [webhookSecrets]);

  const limitedSecret = webhookSecrets.find((c) => c.expiredAt) || {};
  const regularSecret = webhookSecrets.find((c) => !c.expiredAt) || {};

  return (
    <>
      <h3>{strings.appWebhookDetails.text.secretsTitle}</h3>
      <p>{strings.appWebhookDetails.text.secretsDescription}</p>
      <div className={settings.settings__input}>
        <Input
          id="limitedSecret"
          name="limitedSecret"
          label={secretLabel}
          type="text"
          className="input__textfield__settings"
          secondaryClassName="input__textfield__secret"
          thirdClassName="input__textfield__client"
          autoComplete="off"
          value={limitedSecret.signingSecret || ''}
          onClickInputValue={() => {
            if (!!limitedSecret.signingSecret) {
              copy(limitedSecret.signingSecret);
              showSuccess(strings.appWebhookDetails.text.copied);
            }
          }}
          readOnly
          isTypeFieldPasswordCredentials
        />
      </div>
      <div>
        <Input
          id="webhookSecret"
          name="webhookSecret"
          type="text"
          label={strings.appWebhookDetails.fields.webhookSecret}
          className="input__textfield__settings"
          secondaryClassName="input__textfield__secret"
          thirdClassName="input__textfield__client"
          autoComplete="off"
          value={regularSecret.signingSecret || ''}
          onClick={(e) => {
            e.preventDefault();
            dispatch(webhooksActions.setActiveModalDetails({ name: 'new webhook secret' }))
          }}
          onClickInputValue={() => {
            if (!!regularSecret) {
              copy(regularSecret.signingSecret);
              showSuccess(strings.appWebhookDetails.text.copied);
            }
          }}
          readOnly
          isTypeFieldPasswordCredentials
          refreshSecret={<RefreshIcon />}
        />
      </div>
    </>
  );
}

export default WebHookSecrets;
